import { CssBaseline, ThemeProvider } from '@mui/material'
import { queryClient } from '@app/config/queryClient'
import { useSubDomain } from '@app/hooks/useSubdomain'
import { RexRoutes } from '@app/routes/RexRoutes'
import { theme } from '@app/styles/theme'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Provider as JotaiProvider } from 'jotai'
import { DevTools } from 'jotai-devtools'
import css from 'jotai-devtools/styles.css?inline'
import { queryClientAtom } from 'jotai-tanstack-query'
import { useHydrateAtoms } from 'jotai/react/utils'
import { Suspense } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { AuthStateProvider } from '@app/contexts/AuthProvider/AuthProvider'
import { useChangeTempRole } from '@app/modules/Admin/hooks/useChangeTempRole'
import { BuildSash } from './BuildSash'

const JotaiDevTools = () =>
  process.env.NODE_ENV !== 'production' ? (
    <>
      <style>{css}</style>
      <DevTools position="bottom-right" />
    </>
  ) : null

const isDevelopment = process.env.NODE_ENV === 'development'

// local-only helper to hydrate atoms under this Provider
const HydrateAtoms = ({ children }: { children: React.ReactNode }) => {
  useHydrateAtoms([[queryClientAtom, queryClient]])
  return <>{children}</>
}

export const App = () => {
  useSubDomain()
  useChangeTempRole()

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <JotaiProvider>
        <HydrateAtoms>
          {isDevelopment && <JotaiDevTools />}
          <Router>
            <BuildSash />
            {/* NOTICE: AppLoader This is the Old App.tsx will be replaced as refactoring progresses */}
            <AuthStateProvider>
              <Suspense fallback={null}>
                <RexRoutes />
              </Suspense>
            </AuthStateProvider>
          </Router>
          {isDevelopment && <ReactQueryDevtools />}
        </HydrateAtoms>
      </JotaiProvider>
    </ThemeProvider>
  )
}
